
import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { find } from 'lodash';

import { WINDOW } from '../../../../assets/window.providers';
import {
  API_SERVER_BETA_PATH,
  API_SERVER_LIVE_PATH,
  B2B_API_URL_BETA,
  B2B_API_URL_LIVE,
  B2B_STAGE_PATH,
  B2B_API_URL_PREPROD,
} from './api-paths';

import { LOCALE_DOMAINS } from './../../../i18n/locale-domains';
import { DEFAULT_LOCALE } from './../../../i18n/supported-locales';
import { extractCountry } from './../../utils/locale.utils';
import { findDomainByHostname } from '@app/general/services/domains';
import { MEILI_BOOKING_MANAGER_LIVE, PEACH_SCRIPT_LINK, PEACH_TEST_SCRIPT_LINK, WHITE_LABEL_LIST} from '../../../../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private httpClient: HttpClient, @Inject(WINDOW) private window: Window, private injector: Injector) {}

  /**
   *  API server host url path
   */
  public fetchApiHostUrl() {
    if (this.getEnvironment() === 'local') {
      return API_SERVER_BETA_PATH;
    } else if (this.getEnvironment() === 'beta') {
      return API_SERVER_BETA_PATH;
    } else if (this.getEnvironment() === 'preprod') {
      return API_SERVER_LIVE_PATH;
    } else if (this.getEnvironment() === 'live') {
      return API_SERVER_LIVE_PATH;
    }
  }

  public apiBaseUrl(): any {
    let api_Url;
    console.log(this.getEnvironment())
        if (this.getEnvironment() === 'live') {
          api_Url = `${B2B_API_URL_LIVE}${B2B_STAGE_PATH}/`;
        } else if (this.getEnvironment() === 'preprod') {
          api_Url = `${B2B_API_URL_PREPROD}${B2B_STAGE_PATH}/`;
        } else {
          api_Url = `${B2B_API_URL_BETA}${B2B_STAGE_PATH}/`;
        }
    return api_Url;
  }

  public getEnvironment(): string {
    return this.extractWhiteLabelDomain()?.env;
  }

  getPeachScriptUrl() {
    let peach_Url;
    if (this.getEnvironment() === 'live') {
      peach_Url = `${PEACH_SCRIPT_LINK}`;
    } else if (this.getEnvironment() === 'preprod') {
      peach_Url = `${PEACH_TEST_SCRIPT_LINK}`;
    } else {
      peach_Url = `${PEACH_TEST_SCRIPT_LINK}`;
    }
    return peach_Url;
  }
  /*
   * extract the country code from the supported list of hostnames
   */
  public extractCountryFromDomain(): string {
    /**
     * domain name examples
     * var hostname = "www.travelstart.com.na";
     * var hostname = "betana.travelstart.com";
     * and of course there is a localhost in there
     */
    
    const hostname = this.window.location.hostname;
    const country = find(LOCALE_DOMAINS, (localeDomain) => localeDomain.domain === hostname);
    const whiteLabelDomain = findDomainByHostname(hostname);
    if (country) {
      return country.id;
    } else if (whiteLabelDomain?.ts_Country) {
      return whiteLabelDomain.ts_Country;
    } else {
      return extractCountry(DEFAULT_LOCALE);
    }
  }
  /*
   * extract the country code from the supported list of hostnames
   */
  public extractWhiteLabelDomain(): any {
    const hostname = this.window.location.hostname;
    const country = findDomainByHostname(hostname);
    if (country) {
      return country;
    } else {
      return {
        id: 'NG',
        hostname: 'business.travelstart.com',
        b2b_iframe_Link: 'https://www.travelstart.com.ng/',
        TS_ORG: 'TS_NG',
        env: 'live',
        ts_Country: 'NG',
        currency: 'NGN'
      };
    }

  }

  public isFlightsiteDomain() {
    return Boolean(this.extractWhiteLabelDomain()?.TS_ORG === 'TS_FS');
  }
  public toDisplayForWhitelabel() {
    let whitelabelDomain = this.extractWhiteLabelDomain().TS_ORG;
    return WHITE_LABEL_LIST.some((x: any) => x == whitelabelDomain);
  }
  public toDisplayForClubhub() {
    return Boolean(this.extractWhiteLabelDomain().TS_ORG == 'TS_CT');
  }
  getUserEnvironment() {
    return this.extractWhiteLabelDomain()?.env;
  }
  /**currently pointing to prod once testing is done reverted to test URL */
  getMeiliBookingManagerUrl() {
    if (this.getEnvironment() === 'live') {
      return MEILI_BOOKING_MANAGER_LIVE;
    } else {
      // return MEILI_BOOKING_MANAGER_TEST;
      return MEILI_BOOKING_MANAGER_LIVE;
    }
  }
}
